import React from 'react';
import PropTypes from 'prop-types';
import { ButtonBase, Typography } from '@material-ui/core';
import OpacityIcon from '@material-ui/icons/Opacity';
import WavesIcon from '@material-ui/icons/Waves';
import ColorizeIcon from '@material-ui/icons/Colorize';
import StraightenIcon from '@material-ui/icons/Straighten';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import medicionesStyles from './medicionesStyles';

const ICONOS_MODULO = {
	glucometria: OpacityIcon,
	espirometria: WavesIcon,
	lipidograma: ColorizeIcon,
	perimetroAbdominal: StraightenIcon,
};

/**
 * Selector accesible (tablist) de módulos de medición. Cada tab es un
 * <button> nativo: Tab recorre los cuatro, Enter y Espacio activan.
 */
const SelectorModulos = ({ modulos, seleccionado, onSeleccionar, labelledBy, registrados = {} }) => {
	const classes = medicionesStyles();

	return (
		<div role="tablist" aria-labelledby={labelledBy} className={classes.selectorGrid}>
			{modulos.map((modulo) => {
				const Icono = ICONOS_MODULO[modulo.id];
				const activo = modulo.id === seleccionado;
				return (
					<ButtonBase
						key={modulo.id}
						role="tab"
						id={`modulo-tab-${modulo.id}`}
						aria-selected={activo}
						aria-controls={`modulo-panel-${modulo.id}`}
						className={`${classes.tab} ${activo ? classes.tabSelected : ''}`}
						focusVisibleClassName={classes.tabFocusVisible}
						onClick={() => onSeleccionar(modulo.id)}
					>
						<span className={classes.tabIcon}>
							{Icono && <Icono fontSize="small" aria-hidden="true" />}
						</span>
						<span className={classes.tabText}>
							<Typography variant="body2" component="span" className={classes.tabLabel}>
								{modulo.label}
							</Typography>
							<Typography variant="caption" component="span" className={classes.tabDescripcion}>
								{modulo.descripcion}
							</Typography>
							{registrados[modulo.id] && (
								<span className={classes.tabRegistrado}>
									<CheckCircleIcon fontSize="inherit" aria-hidden="true" /> Registrado
								</span>
							)}
						</span>
					</ButtonBase>
				);
			})}
		</div>
	);
};

SelectorModulos.propTypes = {
	modulos: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			descripcion: PropTypes.string,
		})
	).isRequired,
	seleccionado: PropTypes.string.isRequired,
	onSeleccionar: PropTypes.func.isRequired,
	labelledBy: PropTypes.string,
	registrados: PropTypes.objectOf(PropTypes.bool),
};

export default SelectorModulos;
